// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"be4024b7","634":"cbdf17a6","860":"423e09a9"}[chunkId] + ".chunk.js";
};